/** Ranking da viagem — cliente. Agregado no servidor; a tela só desenha. */
import type { RankingCategory, RankingTitle } from '@nv/core';
import { useQuery } from '@tanstack/react-query';

export interface Holder {
  memberId: string;
  name: string;
  value: number;
}

/** Uma linha da classificação completa (todo mundo, com zero; empate divide a posição). */
export interface Standing extends Holder {
  position: number;
}

export interface Ranking {
  currency: string;
  people: { memberId: string; name: string; totalMinor: number; position: number }[];
  titles: { key: RankingTitle; holders: Holder[]; standings: Standing[] }[];
  categories: { category: RankingCategory; holders: Holder[]; standings: Standing[] }[];
  me: { memberId: string; position: number | null; totalMinor: number; titles: RankingTitle[] };
}

async function pedir<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'same-origin', ...init, headers: { ...(init?.body ? { 'content-type': 'application/json' } : {}), ...(init?.headers ?? {}) } });
  if (!res.ok) {
    const corpo = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(corpo.message ?? `Falha (${res.status})`);
  }
  return (await res.json()) as T;
}

export const rankingApi = {
  ler: (tripId: string) => pedir<Ranking>(`/api/v1/trips/${tripId}/ranking`),
};

export function useRanking(tripId: string, ligado = true) {
  return useQuery({ queryKey: ['ranking', tripId], queryFn: () => rankingApi.ler(tripId), enabled: ligado, staleTime: 15_000, refetchInterval: ligado ? 60_000 : false });
}

export interface EvolucaoDoRanking {
  currency: string;
  days: string[];
  series: { memberId: string; name: string; me: boolean; totalsMinor: number[]; positions: number[] }[];
  people: number;
}

export function useEvolucaoDoRanking(tripId: string, ligado = true) {
  return useQuery({ queryKey: ['ranking', tripId, 'evolucao'], queryFn: () => pedir<EvolucaoDoRanking>(`/api/v1/trips/${tripId}/ranking/history`), enabled: ligado, staleTime: 60_000 });
}
